import { render, staticRenderFns } from "./PageBackTitle.vue?vue&type=template&id=f571ab22&scoped=true"
import script from "./PageBackTitle.vue?vue&type=script&lang=js"
export * from "./PageBackTitle.vue?vue&type=script&lang=js"
import style0 from "./PageBackTitle.vue?vue&type=style&index=0&id=f571ab22&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f571ab22",
  null
  
)

export default component.exports